import { useState, useEffect, useMemo } from 'react';
import useSWR from 'swr';
import { expertApi } from 'src/api/expertApi';
import { draftApi } from 'src/api/draftApi';
import toast from 'react-hot-toast';
import { findExpertFromQuery } from 'src/utils/query';

const fetcher = () => expertApi.getExperts();

export const useExpertManagement = (query = null) => {
  const { data: experts, error, isLoading } = useSWR('experts', fetcher);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isLoading && experts && query) {
      const expert = findExpertFromQuery(experts, query);
      setSelectedExpert(expert);
    }
  }, [isLoading, experts, query]);

  // Group experts by company and filter for active experts
  const companiesWithActiveExperts = useMemo(() => {
    if (!experts) return {};

    return experts.reduce((acc, expert) => {
      const company = expert.company || 'Unknown Company';
      if (!acc[company]) {
        acc[company] = {
          company,
          experts: [],
          hasActiveExperts: false,
        };
      }
      acc[company].experts.push(expert);
      if (expert.isActive === 1) {
        acc[company].hasActiveExperts = true;
      }
      return acc;
    }, {});
  }, [experts]);

  const handleExpertDirectoryClick = async (expertID) => {
    setLoading(true);

    try {
      await draftApi.generateInitialEmail(query.id, expertID);
      return true;
    } catch (e) {
      toast.error('Error adding expert:', e);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    experts,
    selectedExpert,
    setSelectedExpert,
    loading,
    handleExpertDirectoryClick,
    error,
    isLoading,
    companiesWithActiveExperts,
  };
};
